import { render } from "./PhotoSection.vue?vue&type=template&id=32b2db54"
import script from "./PhotoSection.vue?vue&type=script&lang=js"
export * from "./PhotoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__